import { JobCardSkeleton } from "@/features/job/components/jobList/JobCardSkeleton";

export const LoadingJobList = () => {
  return (
    <>
      {Array.from(Array(4)).map((_, index) => (
        <JobCardSkeleton key={index} />
      ))}
    </>
  );
};
